@import "../../../theme/global";
/**
* @prop --lar-list-item-padding-top: Top padding of the toolbar
* @prop --lar-list-item-padding-right: End padding of the toolbar
* @prop --lar-list-item-padding-bottom: Bottom padding of the toolbar
* @prop --lar-list-item-padding-left: Start padding of the toolbar
*/
$list-item-padding-top:              var(--lar-list-item-padding-top, .5rem) !default;
$list-item-padding-right:            var(--lar-list-item-padding-right, .5rem) !default;
$list-item-padding-bottom:           var(--lar-list-item-padding-bottom, .5rem) !default;
$list-item-padding-left:             var(--lar-list-item-padding-left, .5rem) !default;

$list-header-font-size:           .9rem !default;
$list-header-font-weight:         500 !default;
$list-header-letter-spacing:      1px !default;
$list-header-text-transform:      uppercase !default;
$list-header-color:               $text-color-step-150 !default;


:host {
  @include font-smoothing();
  @include padding($list-item-padding-top, $list-item-padding-right, $list-item-padding-bottom, $list-item-padding-left);
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}
.item-inner {
  flex: 2;
  flex-direction: inherit;
  align-items: inherit;
  align-self: stretch;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  box-sizing: border-box;
  max-width: 100%;
  width: 100%;
  font-size: $list-header-font-size;
  font-weight: $list-header-font-weight;
  letter-spacing: $list-header-letter-spacing;
  text-transform: $list-header-text-transform;
  color: $list-header-color;
}

:host(:empty) {
  display: none !important;
}
